import * as React from "react";
const SvgIconPlay = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "60px", viewBox: "0 -960 960 960", width: "60px", fill: "#FFFFFF", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M320-202v-560l440 280-440 280Zm66.67-280Zm0 158.67L636-482 386.67-640.67v317.34Z" }));
export default SvgIconPlay;
